import { SVGProps } from '@components/Icon/types';

export const Contacts = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.34229 0C1.94979 0 0 1.94979 0 4.34229V15.6577C0 18.0502 1.94979 20 4.34229 20H15.6577C18.0502 20 20 18.0502 20 15.6577V4.34229C20 1.94979 18.0502 0 15.6577 0H4.34229ZM17.1711 1.54776V4.71476H18.859V4.34229C18.859 3.12415 18.1719 2.08742 17.1711 1.54776ZM17.1711 5.85573V9.42951H18.859V5.85573H17.1711ZM17.1711 10.5705V14.1443H18.859V10.5705H17.1711ZM17.1711 15.2852V18.4522C18.1719 17.9126 18.859 16.8758 18.859 15.6577V15.2852H17.1711ZM2.42572 18.0213C2.39852 17.887 2.40922 17.5861 2.40922 17.5861C2.4111 17.2603 2.61219 16.2844 3.50769 15.3889C4.36876 14.5278 5.98794 13.6303 9.00986 13.6303C12.0318 13.6303 13.651 14.5278 14.512 15.3889C15.4075 16.2844 15.6086 17.2603 15.6105 17.5861C15.6105 18.2615 15.4472 18.7082 14.9581 18.859H4.34229C3.74285 18.859 3.18289 18.6959 2.7042 18.4114C2.61287 18.3338 2.45829 18.1822 2.42572 18.0213ZM4.34229 1.14097C2.56883 1.14097 1.14097 2.56883 1.14097 4.34229V15.6577C1.14097 15.9725 1.18597 16.2765 1.26991 16.5635C1.80677 14.8739 3.69921 12.3102 9.00988 12.3102C12.9529 12.3102 15.0116 13.7235 16.0302 15.143V1.21849C15.9892 1.20904 15.9496 1.19803 15.9126 1.18772L15.8702 1.17604C15.7951 1.15578 15.7278 1.14097 15.6577 1.14097H4.34229Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00988 10.9901C11.1971 10.9901 12.9703 9.21694 12.9703 7.02968C12.9703 4.84241 11.1971 3.06928 9.00988 3.06928C6.82261 3.06928 5.04948 4.84241 5.04948 7.02968C5.04948 9.21694 6.82261 10.9901 9.00988 10.9901ZM9.00988 9.66994C10.4681 9.66994 11.6501 8.48786 11.6501 7.02968C11.6501 5.5715 10.4681 4.38941 9.00988 4.38941C7.5517 4.38941 6.36961 5.5715 6.36961 7.02968C6.36961 8.48786 7.5517 9.66994 9.00988 9.66994Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'contacts';
